import sentry from 'utils/sentry';
import { pauseAutoInvestPlan } from '../actions/autoinvest';
export const pauseAndOptionallySkip = async (planId, pausedUntil, skipUpcoming, expectedPaymentDate, activityId, fetch) => {
    try {
        const result = await fetch(pauseAutoInvestPlan(planId, pausedUntil, skipUpcoming || undefined, expectedPaymentDate, activityId));
        if (!result)
            throw new Error('Pause request returned falsy result');
        return { success: true };
    }
    catch (err) {
        sentry.logError({ message: 'Failed to pause autoinvest', err });
        return { success: false };
    }
};
